<template>
    <div v-if="show">
        <div v-if="errors !== null" class="alert alert-danger" role="alert">
            <div>
                <b>Sikertelen rögzítés!</b>
            </div>
            <div v-for="error in errors">
                {{error}}
            </div>
        </div>
        <div v-else class="alert alert-success" role="alert">
            Mentés sikeres!
        </div>
    </div>
</template>

<script>
    export default{
        name: 'Notification',
        data(){
            return {

            }
        },
        props: {
            show: {
                type: Boolean,
                require: true
            },
            errors: {
                type: Array,
                require: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/worksheet/Notification.vue